import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationAlert from "react-notification-alert";

import {
  get_wallets,
  post_wallets,
  delete_wallets_id,
  put_wallets_id_deposit,
  post_wallets_id_withdraw,
  post_wallets_id_staking,
  post_wallets_id_mtt_swap,
  put_wallets,
} from "stores/Service/actions";

import PayView from "./PayView";
import { getMessage } from "config/util";

const App = ({ nonce }) => {
  const dispatch = useDispatch();
  const ref = useRef();

  const toast = (error) => {
    const message = getMessage(error);
    dispatch_danger(message);
  };

  const dispatch_info = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-bell-55" />
            <span>{message}</span>
          </div>
        ),
        type: "info",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_danger = (message) => {
    if (ref.current) {
      var options = {};
      options = {
        place: "tc",
        message: (
          <div>
            <span data-notify="icon" className="nc-icon nc-single-copy-04" />
            <span>{message}</span>
          </div>
        ),
        type: "danger",
        icon: "now-ui-icons ui-1_bell-53",
        autoDismiss: 5,
      };
      ref.current.notificationAlert(options);
    }
  };

  const dispatch_get_wallets = (data, page) => {
    dispatch(
      get_wallets({
        data,
        toast,
        page,
      })
    );
  };
  const dispatch_post_wallets = (data, page) => {
    dispatch(
      post_wallets({
        data,
        toast,
        page,
      })
    );
  };
  const dispatch_delete_wallets_id = (data, page) => {
    dispatch(
      delete_wallets_id({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_post_wallets_id_withdraw = (data, page) => {
    dispatch(
      post_wallets_id_withdraw({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_put_wallets_id_deposit = (data, page) => {
    dispatch(
      put_wallets_id_deposit({
        data,
        toast,
        page,
      })
    );
  };

  const dispatch_post_wallets_id_staking = (data, page) => {
    dispatch(
      post_wallets_id_staking({
        data,
        toast,
        page,
      })
    );
  };

  // MEMO: MTTスワップは失敗時に画面上へも理由を出したいので、
  // 共通のポップアップ表示に加えて呼び出し側のコールバックも呼ぶ。
  const dispatch_post_wallets_id_mtt_swap = (data, page, on_error) => {
    dispatch(
      post_wallets_id_mtt_swap({
        data,
        toast: (error) => {
          toast(error);
          if (on_error) on_error(getMessage(error));
        },
        page,
      })
    );
  };

  const dispatch_put_wallets = (data, page) => {
    dispatch(
      put_wallets({
        data,
        toast,
        page,
      })
    );
  };

  useEffect(() => {
    dispatch_get_wallets({});
  }, [nonce]);

  return (
    <>
      <div className="notification-container">
        <NotificationAlert ref={ref} />
      </div>
      <div
        style={{
          height: "100%",
          width: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          // overflow: "auto",
        }}
      >
        <PayView
          dispatch_info={dispatch_info}
          dispatch_danger={dispatch_danger}
          dispatch_get_wallets={dispatch_get_wallets}
          dispatch_post_wallets={dispatch_post_wallets}
          dispatch_delete_wallets_id={dispatch_delete_wallets_id}
          dispatch_post_wallets_id_withdraw={dispatch_post_wallets_id_withdraw}
          dispatch_put_wallets_id_deposit={dispatch_put_wallets_id_deposit}
          dispatch_post_wallets_id_staking={dispatch_post_wallets_id_staking}
          dispatch_post_wallets_id_mtt_swap={dispatch_post_wallets_id_mtt_swap}
          dispatch_put_wallets={dispatch_put_wallets}
        />
      </div>
    </>
  );
};

export default App;
